// Depends
import { group } from '@/helpers/routes'
import { routes as dashboard } from './dashboard'

export default [
  ...group('/app/team', [
    ...dashboard
  ])
]



// WEBPACK FOOTER //
// ./src/app/team/routes.js